import TipContainer from './TipContainer';

export default TipContainer;